export class NewProduct{
    constructor(
        public sku: string,
        public manufacturer: string,
        public description: string,
        public is_stock: boolean,
        public is_asset: boolean,
        public assetClass: string
    ){}
}